<div class="d-flex align-items-center justify-content-between p-4 p-md-6 header">
  <h2 class="semi-bold">Itinerary adjusted for price and savings</h2>

  <ds-button
    (click)="hideModal.emit()"
    variant="icon"
    size="s"
    icon="xmark"
    label="Close"
    class="d-none d-md-inline"
    data-id="hide"
  />
</div>

<ng-container *ngIf="presentedOption; else loadingTemplate">
  <div class="m-4 m-md-6 mb-0 p-4 block">
    <div class="d-flex align-items-center">
      <img src="assets/icons/warning.svg" alt="warning" width="20" height="20" />
      <p class="ml-2 semi-bold text-sun-crete-700">New itinerary, same price!</p>
    </div>
    <p class="ml-7 mt-1 text-sun-crete-700">
      Please pay attention that we added bonus flight to you itinerary just to make the whole trip
      cheaper.
    </p>
  </div>

  <div class="d-flex flex-column m-md-6">
    <portal-option
      (requestToBook)="requestToBook.emit(presentedOption)"
      [option]="presentedOption"
      [isPresentation]="true"
      class="option"
      data-id="option"
    />

    <portal-option-details
      [itineraries]="presentedOption.flightItineraries"
      [portalLink]="presentedOption.portalLink"
      class="mt-md-2 mb-4 mb-md-0"
    />
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <div class="d-flex d-md-none flex-column p-4">
    <ds-skeleton [height]="24" class="w-40" />
    <ds-skeleton [height]="20" class="mt-2" />
    <ds-skeleton [height]="288" class="mt-4" />
  </div>

  <div class="d-none d-md-flex flex-column py-4 px-6">
    <ds-skeleton [height]="40" class="w-40" />
    <ds-skeleton [height]="20" class="mt-2" />
    <ds-skeleton [height]="120" class="mt-8" />
  </div>
</ng-template>
